import React, { useEffect, useRef } from "react";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";


delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function CourierMap({
  location,
  surge,
  online,
  navigate,
}) {
  const mapRef = useRef(null);
  const courierMarkerRef = useRef(null);

  const mapContainerRef = useRef(null);

  // 🔥 NEW (IMPORTANT)
  const zonesRef = useRef([]);            // store stable zones
  const surgeCircleRefs = useRef([]);    // store drawn circles

  const surgeControlRef = useRef(null);

  const [zones, setZones] = React.useState([]);

  /* ================= INIT MAP ================= */
  useEffect(() => {
    if (!location) return;

    if (!mapRef.current) {
      mapRef.current = L.map(mapContainerRef.current, {
  center: [location.lat, location.lng],
  zoom: 15,
});

      L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ).addTo(mapRef.current);
    }
  }, [location]);

  /* ================= COURIER MARKER ================= */
  useEffect(() => {
    if (!mapRef.current || !location) return;

    const map = mapRef.current;

    if (!courierMarkerRef.current) {
      courierMarkerRef.current = L.marker([
        location.lat,
        location.lng,
      ]).addTo(map);
    } else {
      courierMarkerRef.current.setLatLng([
        location.lat,
        location.lng,
      ]);
      map.flyTo(
    [location.lat, location.lng],
    map.getZoom(),
    {
        animate: true,
        duration: 1
    }
);
    }
  }, [location]);


  /* ================= LOAD SURGE ZONES ================= */
useEffect(() => {

  if (!online || !location) return;

  const loadZones = async () => {

    try {

      const response = await fetch(

        `https://api.getcoredispatch.cloud/api/surge?lat=${location.lat}&lng=${location.lng}`

      );

      const data = await response.json();

      setZones(data);

    } catch (error) {

      console.log("Failed to load surge zones", error);

    }

  };

  loadZones();

}, [online, location]);


/* ================= DRAW SURGE ZONES ================= */
useEffect(() => {
  if (!mapRef.current || !location) return;

  const map = mapRef.current;

  surgeCircleRefs.current.forEach((item) => {
    if (item?.circle && map.hasLayer(item.circle)) {
      map.removeLayer(item.circle);
    }
  });

  surgeCircleRefs.current = [];

  let nearest = null;

  zones.forEach((zone) => {

const lat = zone.lat;
const lng = zone.lng;

    const distance = map.distance(
      [location.lat, location.lng],
      [lat, lng]
    );

    const circle = L.circle([lat, lng], {
      radius: zone.radius,
      color: "red",
      fillColor: "red",
      fillOpacity: 0.25,
    }).addTo(map);

    circle.bindPopup(
  `🔥 ${zone.multiplier}`
);

    circle.on("click", () => {
      navigate("/courierearnings", {
        state: {
          multiplier: zone.multiplier,
          location: "Hot Zone",
        },
      });
    });

    surgeCircleRefs.current.push({
      circle,
      distance,
    });

    if (!nearest || distance < nearest.distance) {
      nearest = {
        circle,
        distance,
      };
    }
  });

  if (nearest) {
    nearest.circle.setStyle({
      color: "orange",
      fillColor: "orange",
      fillOpacity: 0.5,
    });
  }

}, [zones, location, navigate]);
    
  

  


  /* ================= 🔥 SURGE BUTTON ================= */
  useEffect(() => {
    if (!mapRef.current) return;

    const map = mapRef.current;

    // ✅ Create button ONCE
    if (!surgeControlRef.current) {
      const surgeControl = L.control({ position: "topright" });

      surgeControl.onAdd = function () {
        const div = L.DomUtil.create("div");

        div.innerHTML = `
          <div id="surgeBtn" style="
            background:white;
            padding:8px 12px;
            border-radius:10px;
            font-weight:600;
            cursor:pointer;
            box-shadow:0 2px 6px rgba(0,0,0,0.2);
            animation:pulse 1.5s infinite;
          ">
            🔥 <span id="surgeValue">${online ? surge : "1x"}</span>
          </div>
        `;

        return div;
      };

      surgeControl.addTo(map);
      surgeControlRef.current = surgeControl;

      // Click once
      setTimeout(() => {
        const btn = document.getElementById("surgeBtn");
        if (btn) {
          btn.onclick = () =>
            navigate("/courierearnings", {
              state: { multiplier: surge, location: "Hot Zone" },
            });
        }
      }, 300);
    }

    // ✅ Update value only
    const valueEl = document.getElementById("surgeValue");
    if (valueEl) {
      valueEl.innerText = online ? surge : "1x";
    }

  }, [surge, online]);

  return (
    <>
      {/* Pulse animation */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
      </style>

      {/* Map */}
      <div
  ref={mapContainerRef}
  style={{
    height: "400px",
    width: "100%",
    borderRadius: "12px",
  }}
/>
    </>
  );
}